/*
 * PushMenu JS for the disclosure menu hamburger button
 */

'use strict';

const Default = {
    enableRemember: true,
    autoCollapseSize: 768,
}

class PushMenu {
    constructor(element, config) {
        this.bodyNode = document.querySelector('body');
        this.rootNode = element;
        this._options = $.extend({}, Default, config);
        this.autoCollapseNode = null;
        this.ariaControlsNode = null;

        // Get auto collapse node selector
        if (this.rootNode.hasAttribute('data-autoCollapse')) {
            // Get the auto collapse node
            this.autoCollapseNode = document.querySelector(this.rootNode.getAttribute('data-autoCollapse'));
        }

        // Get auto aria-hidden node selector
        if (this.rootNode.hasAttribute('data-ariaControls')) {
            // Get the auto aria-hidden node
            this.ariaControlsNode = document.querySelector(this.rootNode.getAttribute('data-ariaControls'));
        }

        // Which node should be controlled
        if (this.rootNode.hasAttribute('aria-controls')) {
            this.controlledNode = document.querySelector('#' + this.rootNode.getAttribute('aria-controls'));
        }

        // We need to have a controlled node
        if (!this.controlledNode) {
            console.log('aria-controls attribute must point to a valid DOM element');
            return
        }

        this._init();
    }

    expand(looseFocus = false) {
        // Remove the toggled class
        if (this.controlledNode.classList.contains('toggled') === true) {
            this.controlledNode.classList.remove('toggled');
        }

        // Remove the sidebar-collapsed class
        if (this.bodyNode.classList.contains('sidebar-collapsed') === true) {
            this.bodyNode.classList.remove('sidebar-collapsed');
        }

        // Set the aria-expanded attribute to true
        if (this.rootNode.hasAttribute('aria-expanded')) {
            this.rootNode.setAttribute('aria-expanded', 'true');
        }

        // Loose focus
        if (this.autoCollapseNode !== null && looseFocus === true) {
            this.autoCollapseNode.focus({
                preventScroll: true
            });
        }

        // Save current state to localStorage
        if (this._options.enableRemember) {
            localStorage.setItem(`remember.pushmenu.expanded`, 'true');
        }

        // Show sidebar for aria controlled users
        if (this.ariaControlsNode !== null && this.ariaControlsNode.hasAttribute('aria-hidden')) {
            this.ariaControlsNode.setAttribute('aria-hidden', 'false');
        }

        // Fire event
        this.rootNode.dispatchEvent(
            new CustomEvent("sidebar", {
                expanded: true,
            }),
        );
    }

    collapse(looseFocus = false) {
        // Add the toggled class
        if (this.controlledNode.classList.contains('toggled') === false) {
            this.controlledNode.classList.add('toggled');
        }

        // Add the sidebar-collapsed class
        if (this.bodyNode.classList.contains('sidebar-collapsed') === false) {
            this.bodyNode.classList.add('sidebar-collapsed');
        }

        // Set the aria-expanded attribute to false
        if (this.rootNode.hasAttribute('aria-expanded')) {
            this.rootNode.setAttribute('aria-expanded', 'false');
        }

        // Loose focus
        if (this.autoCollapseNode !== null && looseFocus === true) {
            this.autoCollapseNode.focus({
                preventScroll: true
            });
        }

        // Save current state to localStorage
        if (this._options.enableRemember) {
            localStorage.setItem(`remember.pushmenu.expanded`, 'false');
        }

        // Hide sidebar for aria controlled users
        if (this.ariaControlsNode !== null && this.ariaControlsNode.hasAttribute('aria-hidden')) {
            this.ariaControlsNode.setAttribute('aria-hidden', 'true');
        }

        // Fire event
        this.rootNode.dispatchEvent(
            new CustomEvent("sidebar", {
                expanded: false,
            }),
        );
    }

    toggle() {
        // Toggle the sidebar
        if (this.controlledNode.classList.contains('toggled') === true) {
            this.expand(false);
        } else {
            this.collapse(true);
        }
    }

    autoCollapse() {
        // Get window width
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        // Collapse the sidebar if the window width is less than the autoCollapseSize
        if (width <= this._options.autoCollapseSize) {
            this.collapse(true);
        }
    }

    _init() {
        // Add event listenter to the root node
        this.rootNode.addEventListener('click', this.toggle.bind(this));
        this.rootNode.addEventListener('touch', this.toggle.bind(this));

        // Auto hide the sidebar on main click on small screens
        if (this.autoCollapseNode !== null && this._options.autoCollapseSize && this._options.autoCollapseSize >= 0) {
            this.autoCollapseNode.addEventListener('click', this.autoCollapse.bind(this));
            this.autoCollapseNode.addEventListener('touch', this.autoCollapse.bind(this));
        }

        // Check if the sidebar should be expanded or collapsed
        if (!this._options.enableRemember) {
            return
        }

        // Get the toggle state from localStorage
        const toggleState = localStorage.getItem(`remember.pushmenu.expanded`);

        // Avoid transaction on reload
        this.controlledNode.classList.add('hold-transition');

        if (toggleState === 'false') {
            this.collapse(false);
        } else {
            this.expand(false);
        }

        // Avoid transaction on reload
        setTimeout(() => {
            this.controlledNode.classList.remove('hold-transition');
        }, 400)
    }
}

/* Initialize Sidebar Menus */
window.addEventListener('load', function () {
    var pushmenus = document.querySelectorAll('.toggle-sidebar');
    var sidebarMenus = [];

    for (var i = 0; i < pushmenus.length; i++) {
        sidebarMenus[i] = new PushMenu(pushmenus[i]);
    }
}, false);
